<template>
  <div
    v-intersect="{
      handler: onIntersect,
      options: {
        rootMargin: '-84px',
        threshold: 0.3
      }
    }"
  >
    <!-- Блок показываемый в режиме НЕ редактирования -->
    <v-container v-if="!editingMode" class="ma-0 py-0 px-2">
      <v-row class="pa-0 ma-0">
        <v-col cols="10" sm="11" class="font-weight-bold py-2 px-0 ma-0">
          <span>{{ article.title }}</span>
        </v-col>
        <v-col v-if="adminMode" cols="2" sm="1" class="py-2">
          <EditButton @click="goToManageArticlePage"></EditButton>
        </v-col>
      </v-row>
      <v-row v-if="adminMode" class="pa-0 ma-0">
        <v-col cols="10" sm="11" class="py-2 px-0 ma-0">
          <span v-if="adminMode">{{getHost}}/shared/{{articleSharingCode}}</span>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        pa-0
        ma-0
        class="font-italic font-weight-medium grey--text text--darken-2 overline"
      >
        <v-col cols="6" class="pa-0 ma-0 text-left">
          <span>
            {{
            showArticleEventDate(
            article.start_event_date,
            article.event_date,
            article.event_date_title
            )
            }}
          </span>
        </v-col>

        <v-col cols="6" class="pa-0 ma-0 text-right">
          <span>{{ authorLabel }}</span>

          <span v-if="article.author">{{ article.author_info.name }}</span>
        </v-col>
      </v-row>
      <v-row v-if="adminMode && !article.publication_date">
        <v-col cols="12">
          <v-alert type="warning">
            Пост не опубликован! Остальные пользователи не увидят текст пока вы
            не опубликуете пост. Сейчас им видны только картинки и видео.
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
    <!----------------------------------------------->
    <!-- Блок показываемый в режиме редактирования -->
    <v-card v-if="adminMode && editingMode" color="grey lighten-3" class="ma-2">
      <v-form v-model="formIsValid" ref="form">
        <v-container class="ma-0 py-0 px-2">
          <v-row>
            <v-col cols="12" class="pt-2">
              <v-text-field
                v-model="titleText"
                dense
                outlined
                :rules="[rules.required]"
                hide-details="auto"
                background-color="white"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters pa-0 ma-0>
            <v-col cols="12" sm="6" class="pa-0 ma-0 text-left">
              <DatePicker
                v-model="eventDate"
                type="datetime"
                value-type="date"
                format="D MMMM YYYY (HH ч.)"
                :clearable="false"
              ></DatePicker>
            </v-col>

            <v-col cols="6" class="pa-0 ma-0">
              <v-row justify="end">
                <v-select
                  :label="authorLabel"
                  :items="getAuthorsList"
                  v-model="authorId"
                  dense
                  outlined
                  hide-details="auto"
                  class="ma-4 my-sm-0"
                  background-color="white"
                ></v-select>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters pa-0 ma-0>
            <v-col cols="8" sm="3">
              <v-checkbox
                v-if="!article.publication_date"
                v-model="publish"
                label="Опубликовать пост"
                background-color="orange"
                dark
              ></v-checkbox>
            </v-col>
            <v-col cols="4" sm="9" class="text-right">
              <v-btn
                icon
                :loading="apiLoadingData"
                color="green"
                :disabled="!formIsValid"
                @click="updateArticle"
              >
                <v-icon>mdi-check-outline</v-icon>
              </v-btn>
              <v-btn icon color="red" @click="cancelEditing">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-alert v-model="showErrorAlert" type="error" dismissible>{{ errorMessage }}</v-alert>
    </v-card>
    <!----------------------------------------------->
  </div>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import { adminOptionsComputed } from '@/store/helpers.js'
import { showArticleEventDate } from '@/helpers/helpers.js'
import { showDate } from '@/helpers/helpers.js'
import { editingLogicMixin } from '@/components/mixins/editing'
import { generateHashedIDs} from '@/helpers/helpers.js'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

import EditButton from '@/components/EditButton.vue'

export default {
  components: {
    DatePicker,
    EditButton
  },
  mixins: [editingLogicMixin],
  props: {
    article: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      titleText: '',
      eventDate: null,
      authorId: null,
      publish: false,

      rules: {
        required: value =>
          !!value || 'Не, пустое нельзя, должно же быть какое-то название'
      }
    }
  },
  computed: {
    ...adminOptionsComputed,

    getAuthorsList() {
      return this.$store.getters.getAuthorsList
    },
    authorLabel() {
      if (!this.article.author) {
        return ''
      }
      if (this.article.publication_date) {
        return 'Автор:'
      }
      return 'Будущий автор:'
    },
    getHost(){
      return window.location.host
    },
    articleSharingCode(){
      
      return generateHashedIDs(this.article.id)
    }
  },

  created() {
    this.$store.dispatch('fetchAdministrators')
  },
  methods: {
    showArticleEventDate,
    showDate,
    setData() {
      const apiData = {}
      apiData.title = this.titleText
      apiData.event_date = showDate(this.eventDate, 'YYYY-MM-DDTHH:mm:ss')
      apiData.author = this.authorId
      if (!this.article.publication_date && this.publish) {
        apiData.publication_date = new Date()
      }
      return apiData
    },

    initData() {
      this.titleText = this.article.title
      this.eventDate = new Date(this.article.event_date)
      this.authorId = this.article.author
      this.publish = false
    },

    updateArticle() {
      this.updateData(APIService.updateArticle, this.article.id)
    },

    // eslint-disable-next-line no-unused-vars
    onIntersect(entries, observer) {
      if (entries[0].isIntersecting) {
        this.$emit('enteringScreen', this.article)
      } else {
        if (entries[0].boundingClientRect.y < 84) {
          this.$emit('leavingScreen', this.article)
        }
      }
    },
    goToManageArticlePage() {
      console.log('GO TO managearticle/' + this.article.id)
      this.$router.push('/managearticle/' + this.article.id)
    }
  }
}
</script>

<style></style>
